export default {
  signInWithSlack: `https://github.com/invokemedia/harvey-serverless`,
  addToSlack: `https://github.com/invokemedia/harvey-serverless`
}